import Cookie from 'js.cookie';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // toggles hamburger and nav open and closed states
    var removeClass = true;
    $('.hamburger').click(function () {
      $('.hamburger').toggleClass('is-active');
      $('#sideNav').toggleClass('sideNav-open');
      $('.sideNavBody').toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $('.sideNav').click(function() {
      removeClass = false;
    });

    document.addEventListener('touchstart', function(e) {
      if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
        $('.hamburger').removeClass('is-active');
        $('#sideNav').removeClass('sideNav-open');
        $('.sideNavBody').removeClass('sideNavBody-push');
      }
      removeClass = true;
    }, false);

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function () {
      $('html, body').animate({
        scrollTop: 0,
      }, 600);
      return false;
    });

    if ($('.testimonials-carousel').length) {
      $('.testimonials-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        appendArrows: '.testimonials-panel .slider-nav',
        appendDots: '.testimonials-panel .slider-nav',
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
            },
          },
        ],
      });
    }

    if ($('.locations-carousel').length) {
      $('.locations-carousel').slick({
        slidesToShow: 6,
        slidesToScroll: 2,
        appendArrows: '.locations-panel .slider-nav-locations',
        appendDots: '.locations-panel .slider-nav-locations',
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
        ],
      });
    }

    $('.gallery-carousel').each(function() {
      var slider = $(this);
      if ($('.gallery-carousel').length) {
        slider.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          appendArrows: slider,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 1399,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },

            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
    });

    $('.project-gallery').lightGallery({
    selector: '.project-gallery .gallery-image',
    });

    $('.locations-menu').removeClass('active');

    $('.locations-dropdown-backend, .locations-menu').hover(function() {
      $('.locations-menu').toggleClass('active');
    });

    $('.locations-dropdown-backend-mobile').click(function(e) {
      // $('.locations-menu-mobile').toggleClass('active');
      e.preventDefault();
      $('.locations-menu-mobile').slideToggle();
    });

    $('.sideNav .menu-item-has-children > a').click(function(e){
        e.preventDefault();
        $(this).next('.sub-menu').slideToggle();
    });

    var locations_dropdown = $('.locations-dropdown');
    $('.menu-locations').addClass('menu-item-has-children').append(locations_dropdown);
    
    if (!Cookie.get('alert') && $('#modal').length) {
      $('#modal').show();
    }
    
    $('.modal .btn-close').click(function() {
      $('#modal').hide();
      Cookie.set('alert', true, {
        expires: 1,
      });
    });
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js